document.addEventListener("DOMContentLoaded", function () {
    class SlideShowCustom extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.slideshow();
        }

        slideshow() {
            const swiperContainer = this.querySelector(".swiper");
            
            // --- 获取并处理数据 ---
            // dataset.autoplay 获取的是字符串 "true" 或 "false"
            const isAutoplay = this.dataset.autoplay === 'true';
            // 获取延迟时间，并转化为整数
            const autoplayDelay = parseInt(this.dataset.delay) || 5000;

            new Swiper(swiperContainer, {
                loop: true,
                // --- 自动轮播逻辑 ---
                autoplay: isAutoplay ? {
                    delay: autoplayDelay,
                    disableOnInteraction: false, // 用户操作后不停止自动轮播
                    pauseOnMouseEnter: true      // 鼠标悬停时暂停，提升用户体验
                } : false, 
                
                navigation: {
                    // 这里的 navigation 依然绑定你父级盒子下的按钮
                    nextEl: this.parentElement.querySelector(".swiper-button-next"),
                    prevEl: this.parentElement.querySelector(".swiper-button-prev"),
                },
            });
        }
    }

    if (!window.customElements.get("slideshow-images")) {
        window.customElements.define("slideshow-images", SlideShowCustom);
    }
});